import Vue from 'vue'
import Cookies from 'js-cookie';

import { store } from './store/_store.js';

import SlimUploader from './components/SlimUploader.vue'
import StoreInit from './components/StoreInit.vue'
import BaselinesSettings from './components/BaselinesSettings.vue';
import CandidateSearch from './components/CandidateSearch.vue';
import PersonSpecCrud from './components/PersonSpecs/Crud.vue';
import PendingRequisitions from './components/Requisitions/Pending.vue';
import ActiveRequisitions from './components/Requisitions/Active.vue';
import RequisitionCrud from './components/Requisitions/Crud.vue';
import AdCreationButton from './components/Requisitions/AdCreationButton.vue';
import RequisitionAdCrud from './components/Requisitions/AdCrud.vue';
import RequisitionApplicants from './components/Requisitions/Applicants.vue';
import JobApplicationsAccordion from './components/JobApplications/CandidateAccordion.vue';
import RequisitionApplicant from './components/Requisitions/Applicant.vue';
import MoveToRequisitionButton from './components/Requisitions/MoveToRequisitionButton.vue';
import FailBin from './components/Requisitions/FailBin.vue';
import Tabs from './components/Tabs.vue';
import Tab from './components/Tab.vue';
import Modal from './components/Modal.vue';
import ModalCompleteCellphone from './components/ModalCompleteCellphone.vue';
import IfactFormAccordion from './components/Ifact/IfactFormAccordion.vue';
import IfactFormUploadModal from './components/Requisitions/Applicant/IfactFormUploadModal.vue';
import IfactCandidateDashboard from './components/Ifact/IfactCandidateDashboard.vue';
import ApplicantsSidebar from './components/Requisitions/ApplicantsSidebar.vue';
import ModalRejectAccountActivation from './components/Admin/ModalRejectAccountActivation.vue';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = Cookies.get('csrfToken');

import 'vue-select/dist/vue-select.css';

import ModalSignature from './components/ModalSignature.vue';
// END GLOBAL COMPONENT IMPORT

//candidate dashboar
import ToggleProfileButton from './components/Candidate/ToggleProfileButton.vue';
import ProfileCompletion from './components/Candidate/ProfileCompletion.vue';
import SideBarDrawer from './components/Candidate/SideBarDrawer.vue'
import ProgressKnob from './components/ProgressKnob.vue';

// Register a global filter
Vue.filter('properCase', function (value) {
	if (!value) return '';
	return value
		.split(' ')
		.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ');
});

var app = new Vue({
	el: '#app',
	store,
	data: {
		items: []
	},
	// store,
	components: {
		AdCreationButton,
		StoreInit,
		SlimUploader,
		BaselinesSettings,
		CandidateSearch,
		PersonSpecCrud,
		PendingRequisitions,
		RequisitionCrud,
		RequisitionAdCrud,
		ActiveRequisitions,
		RequisitionApplicants,
		JobApplicationsAccordion,
		RequisitionApplicant,
		FailBin,
		Tabs,
		Tab,
		MoveToRequisitionButton,
		Modal,
		ModalCompleteCellphone,
		IfactFormAccordion,
		ModalSignature,
		IfactFormUploadModal,
		IfactCandidateDashboard,
		ToggleProfileButton,
		ProfileCompletion,
		SideBarDrawer,
		ProgressKnob,
		ApplicantsSidebar,
		ModalRejectAccountActivation
	},
});